import React from "react"
import { Card, Grid, Header } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { ReactComponent as WorkPauseIcon } from "uikit/Icons/workpause-goal.svg"
// import { formatCurrency } from "uikit"

const WorkPause = ({
  id,
  people,
  baseUrl,
  type,
  person_id,
  subtype,
  start_date,
  end_date
}) => {
  return (
    <Card>
      <Card.Content>
        <Link
          to={`${baseUrl}/goals/${id}/${type.toLowerCase()}`}
          className="navlink"
        >
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column verticalAlign="middle" width={4}>
                <WorkPauseIcon />
                <Header
                  as="h2"
                  content={start_date.slice(0, 4)}
                  textAlign="center"
                  style={{ marginTop: "0" }}
                />
              </Grid.Column>
              <Grid.Column>
                <Grid>
                  <Grid.Row columns={1}>
                    <Grid.Column>
                      <span className="GenericCard__LinkTitle">
                        {`Weather the Storm`}
                      </span>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2} style={{ paddingTop: "0px" }}>
                    <Grid.Column>
                      <p
                        className="GoalCard_Price"
                        style={{
                          fontSize: "2.4em",
                          marginBottom: "0",
                          color: "#8ed72a"
                        }}
                      >
                        {end_date.slice(5)}
                      </p>
                      <p className="greyed-text">end date</p>
                    </Grid.Column>
                    <Grid.Column
                      style={{ paddingRight: "24px", textAlign: "right" }}
                      className="greyed-text"
                    >
                      <p
                        className="GoalCard_SecondText"
                        style={{
                          fontSize: "2.4em",
                          marginBottom: "0",
                          color: "#8ed72a"
                        }}
                      >
                        {people[person_id].first_name}
                      </p>
                      <p className="greyed-text">{subtype}</p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Link>
      </Card.Content>
    </Card>
  )
}
export default WorkPause
